export default __webpack_public_path__ + "static/Anationwithoutaccesstoitsownsea-1711881cf37c66ec49c3a360e08318ad.jpg";